<template>
	<div>
		<em class="lt_text">Item </em>
		<span class="int_type" style="width:550px;">
			<AC ref="ac" :disableInput="disabled" :inputClass="{ bg_disabled: disabled }" :source="selectACItems" @selected="selectACItem" :resultsDisplay="resultsDisplay" placeholder="Item / Name or ID"> </AC>
		</span>
		<span class="int_type" style="width:300px;">
			<input type="text" :disabled="disabled" :class="{ bg_disabled: disabled }" :value="value" autocomplete="off" @focus="$event.target.select()" @input="emitChange($event.target.value)" />
		</span>
	</div>
</template>

<script>
import AC from '@/components/common/AC';
export default {
	props: {
		value: {
			type: String,
		},
		active_only: {
			type: Boolean,
			default: false,
		},
		separator: {
			type: String,
			default: ',',
		},
		resultsDisplay: {
			type: [String, Function],
			default: 'id_name',
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		AC,
	},
	computed: {
		user() {
			return this.$session.get('user');
		},
		selected_item_codes() {
			return this.value ? this.value.split(this.separator) : [];
		},
	},
	methods: {
		selectACItems(input) {
			var url = process.env.VUE_APP_API_URL + '/api/item/item_master/acItemList?company_id=' + this.user.company_id + '&active_only=' + this.active_only + '&keyword=' + input;
			return url;
		},
		selectACItem(i) {
			const idx = this.selected_item_codes.findIndex(it => it === i.selectedObject.item_code);

			if (idx < 0) this.emitChange(this.value + (this.value ? this.separator : '') + i.selectedObject.item_code);
			else this.$toast.error('Already Selected Item.');
		},
		emitChange(str) {
			this.$emit('input', str);
		},
	},
};
</script>

<style></style>
